import { withConfigTransport } from '../../services/config-transport/withConfigTransport'
import _VaFormField from './VaFormField.vue'

export const VaFormField = withConfigTransport(_VaFormField)
